export const LoginType = {
  WECHAT: 'wechat',
  PHONE: 'phone',
}
